import { render, staticRenderFns } from "./InstitutionsList.vue?vue&type=template&id=3878e1aa&scoped=true&"
import script from "./InstitutionsList.vue?vue&type=script&lang=js&"
export * from "./InstitutionsList.vue?vue&type=script&lang=js&"
import style0 from "./InstitutionsList.vue?vue&type=style&index=0&id=3878e1aa&scoped=true&lang=scss&"
import style1 from "./InstitutionsList.vue?vue&type=style&index=1&id=3878e1aa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3878e1aa",
  null
  
)

export default component.exports